module.exports = __webpack_public_path__ + "img/Slider_Industria.1ff4ce3e.jpg";